export interface EventObjective {
    id?: number;
    name: string;
    is_active: boolean;
}

export interface EventObjectiveFilters {
    page: number;
    per_page: number;
    sort: string;
    order: string;
    name?: string;
    is_active?: boolean;
}

export const defaultEventObjective: EventObjective = {
    name: '',
    is_active: true
}; 